export const navigateWithPageReload = (path: string) => {
  window.location.href = path;
};
